import React, { memo } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import mediaQuery from '../../utils/helper/mediaQuery'
import NavResponsive from './NavResponsive'

const Layout = ({ ...rest }) => {
  const mobile = mediaQuery().mobile
  return (
    <div className="!max-w-screen min-h-screen !w-full overflow-x-hidden bg-slate-50">
      {!mobile && <Sidebar />}
      <Topbar />
      <div
        className={`relative ${!mobile ? 'left-[100px]' : 'px-3'} flex flex-col pb-4 pt-[88px]`}
        style={{ maxWidth: mobile ? '100vw' : 'calc(100vw - 150px)' }}
        {...rest}
      >
        <Outlet />
      </div>
      {mobile && <NavResponsive />}
    </div>
  )
}

export default memo(Layout)
